import styled from 'styled-components'
import {mediumSmallFont, smallFont} from '../../../../../theme/font-styles'
import {spacing} from '../../../../../theme/spacing'

export const Wrapper = styled.div``

export const Header = styled.div`
    background: none;
    border: none;
    padding: 7px 13px;
    ${mediumSmallFont()}
    color: ${(props) => props.theme.colors.link.primary};
    font-weight: ${(props) => props.theme.font.weight.semibold};
    min-width: 110px;
    text-align: center;
`

export const TrackingIdArea = styled.div`
    display: flex;
    flex: 1;
`

export const TrackingIdValue = styled.div`
    width: 300px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: break-word;
    color: ${(props) => props.theme.chrList.dataRow.text};
    background-color: ${(props) => props.theme.chrList.dataRow.background};
    padding: ${spacing(2)};
    margin-left: ${spacing(10)};
    box-shadow: 1px 1px 6px -2px rgba(0, 0, 0, 0.3);
    ${mediumSmallFont()}
`

export const CopyButton = styled.button`
    display: flex;
    align-items: center;
    background: none;
    border: none;
    padding: ${spacing(1)} ${spacing(2)};
    ${smallFont()}
    color: ${(props) => props.theme.chrList.link.primary};
    font-weight: ${(props) => props.theme.font.weight.semibold};

    &:hover {
        background-color: ${(props) => props.theme.chrList.link.hoverBackground};
    }
`

export const IconText = styled.div`
    margin-left: ${spacing(1)};
`
